module.exports = __webpack_public_path__ + "static/media/spinner.fb127bcf.gif";